// vrDebug.js
var VrDebug = pc.createScript('vrDebug');

VrDebug.attributes.add('textObj', {type:'entity', title: 'txtObj1', array: true});


// initialize code called once per entity
VrDebug.prototype.initialize = function() {
    this.app.on('debug', this.setDebug);
    to = this.textObj;
};

VrDebug.prototype.setDebug = function(title, value, order) {
    var e = to[order];
    e.element.text = title + " " + value;
};

// update code called every frame
VrDebug.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// VrDebug.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

